module.exports = __webpack_public_path__ + "img/majesty_natural_ba_list.7ec24794.jpg";